import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const usePaginatedItems = (items, itemsPerPage, limit) => {
  const [searchParams] = useSearchParams();
  const currentPage = +searchParams.get('p');

  return useMemo(() => {
    if (!items) return [];
    if (currentPage) {
      const offset = currentPage * itemsPerPage - itemsPerPage;
      return items.slice(offset, offset + itemsPerPage);
    }
    return items.slice(0, limit);
  }, [currentPage, items, itemsPerPage, limit]);
};
